import React from 'react';
import DropdownFilterCell from './DropdownFilterCell';

const NestedEntityNamesFilterCell = (names) => (props) => <DropdownFilterCell {...props} data={names} />;

export default NestedEntityNamesFilterCell;
